import { InstitutionSelection } from '@/report-app/pages/institution/selection'
import React, { useEffect, useCallback } from 'react'
import { useReduxState } from '@/hooks/reduxState'
import { redirectToReturnUrl } from '@/components/auth/authProvider'
import { useLocalization } from '@/hooks/localization'
import LogoutButton from '@/components/auth/LogoutButton'
import { DataLoader } from '@/components/dataLoader'
import context from '@/context'
import LoadingIndicator from '@/components/LoadingIndicator'

const InstitutionAccessVerifier = ({ children, localize }) => {
  const renderContent = useCallback(({ data: hasAccess, loading }) => {
    return (
      <div>
        {loading
          ? <LoadingIndicator />
          : hasAccess ? children : <p>{localize('Institutions.NoInstitutionAccess')}</p> }
      </div>
    )
  }, [localize, children])
  return (
    <DataLoader
      dataSource={context.api.institutionService.hasAnyInstitutionAccess}
      render={renderContent}
    />
  )
}
const InstitutionSelectionPage = React.memo(function InstitutionSelectionPage () {
  const institutionSelected = useReduxState(state => !!(state.identity && state.identity.user && state.identity.user.profile && state.identity.user.profile.InstitutionId))
  const { localize } = useLocalization()
  useEffect(() => {
    if (institutionSelected) {
      redirectToReturnUrl()
    }
  }, [institutionSelected])

  return (
    <div className='login-box'>
      <h2>{localize('Institutions.SelectOneTitle')}</h2>
      <InstitutionAccessVerifier localize={localize}>
        <InstitutionSelection />
      </InstitutionAccessVerifier>
      <div style={{ width: '100%', textAlign: 'center', marginTop: 20 }}><LogoutButton clean /></div>
    </div>
  )
})

export {
  InstitutionSelectionPage
}



// WEBPACK FOOTER //
// ./src/components/auth/institutionSelection.js